"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutcomeDropdownContainerStyle = exports.OutcomeDropdownValueStyle = exports.OutcomeDropdownDataTypeIconStyle = exports.OutcomeDropdownItemStyle = void 0;
var StyleHelper_1 = require("./StyleHelper");
exports.OutcomeDropdownItemStyle = (0, StyleHelper_1.cssClass)('OutcomeDropdownItemStyle', {
    paddingTop: 8,
    paddingBottom: 8,
    whiteSpace: 'normal',
    overflow: 'hidden',
});
exports.OutcomeDropdownDataTypeIconStyle = (0, StyleHelper_1.cssClass)('OutcomeDropdownDataTypeIconStyle', {
    float: 'left',
    marginRight: 10,
});
exports.OutcomeDropdownValueStyle = (0, StyleHelper_1.cssClass)('OutcomeDropdownValueStyle', {
    fontWeight: 'bold',
    paddingBottom: 5,
});
exports.OutcomeDropdownContainerStyle = (0, StyleHelper_1.cssClass)('consOutcomeDropdownContainerStyle', {
    width: '100%',
    marginTop: '10px',
    display: 'fixed',
});
//# sourceMappingURL=ObjectiveSelectionStyles.js.map